module.exports = __webpack_public_path__ + "assets/img/tx121_4.0f179a6e.jpg";